import React, { useState, useRef, useEffect } from 'react'
import './ListeningGuide.css';
// ASSETS
// import audioTrack from '../../assets/bach-g-minor-little.mp3';
// import videoTrack from '../../assets/2-1B.mp4'
// import Data from "../../Data/data.json";

// COMPONENTS
import AnnotationSection from '../AnnotationSection/AnnotationSection';
import AudioControlsSection from '../AudioControlsSection/AudioControlsSection';

function ListeningGuide({ Data, videoTrack }) {
  // const [importPath, setImportPath] = useState(`/Data/data.json`)
  // useEffect(() => {
  //   const url = new URL(window.location)
  //   setImportPath(url.pathname)
  // }, [])
  // const [Data, setData] = useState(Data)
  // useEffect(() => {
  //   console.log(importPath)
  //   if (importPath) {
  //     import(`./Data${importPath}`).then(module => setData(module))
  //   }
  // }, [importPath])


  // AUDIO TRACK REF
  const audRef = useRef(null);  //HTML media element
  // HOOKS
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false)
  const [timelineIndex, setTimelineIndex] = useState(0)
  // EVENT LISTENERS
  // fires any time position in audio track changes; saves time position in state and fetches appropriate refs
  const handleTimeUpdated = (e) => {
    const updatedTime = e.target.currentTime
    setCurrentTime(updatedTime)
    getSection(updatedTime);
  }
  // fires when audio track is loaded
  const handleDataLoaded = () => {
    setDataLoaded(true)
  }
  // fires when audio reaches end of track
  const handleEnded = () => {
    setIsPlaying(false)
  }
  // HELPER FUNCTIONS
  const getSection = (currentTime) => {
    Data.enableMod[0].interact.timelines.forEach((timeline, index) => {
      if (parseFloat(timeline.frames[0].in) <= parseFloat(currentTime) && parseFloat(currentTime) < parseFloat(timeline.frames[0].out)) {
        setTimelineIndex(index)
      }
    })
  }

  const getTimelineHeader = (timelineType) => {
    // console.log(color)
    if (timelineType === "getting-started") { return "Getting Started" }
    if (timelineType === "content") { return "Content" }
    if (timelineType === "delivery") { return "Delivery" }
    if (timelineType === "engaging-your-audience") { return "Engaging Your Audience" }
    if (timelineType === "fundamentals") { return "Fundamentals" }
    // if (timelineType === "resources") { return resourcesPNG }
    if (timelineType === "speaking-to-inform") { return "Speaking to Inform" }
    if (timelineType === "speaking-occasions") { return "Speaking Occasions" }
    if (timelineType === "speaking-to-persuade") { return "Speaking to Persuade" }

  }

  const formatSectionHeaderStr = (str, timelineType) => {
    const formattedStr = str.replace(/<br\s*\/?>/gi, ': ')
    if (timelineType) {
      const headerStr = getTimelineHeader(timelineType)
      return (`${headerStr} - ${formattedStr}`)
    } else {
      return formattedStr
    }
  }
  const updateTime = (time) => {
    setCurrentTime(parseFloat(time))
    audRef.current.currentTime = time
  }
  // converts time from seconds to 00:00:00 format
  const formatTime = (time) => {
    // const date = new Date(time)
    // date.setSeconds(time)
    // console.log(date)
    const minsCalc = Math.floor(parseFloat(time) / 60)
    const mins = minsCalc.toString().length < 2 ? ('0' + minsCalc) : minsCalc
    const secondsCalc = Math.round((parseFloat(time) % 60))
    const seconds = secondsCalc.toString().length < 2 ? ('0' + secondsCalc) : secondsCalc
    // const hundredthsCalc = Math.floor((parseFloat(time) % 1) * 100)
    // const hundredths = hundredthsCalc.toString().length < 2 ? ('0' + hundredthsCalc) : hundredthsCalc
    const curTime = `${mins}:${seconds}`
    return curTime
  }

  const [version, setVersion] = useState("")

  useEffect(() => {
    const url = new URL(document.location)
    console.log(url)
    const params = url.hash.split('version=').pop()
    console.log(params)
    setVersion(params)
  }, [])

  return (
    <div className={version !== "new" ? "mock-iframe" : "listening-guide-frame"}>
      <div className={version !== "new" ? "listening-guide-container-frame" : "listening-guide-container"}>
        {Data ?
          <div className="App">
            <video
              // controls
              playsInline
              onLoadedData={handleDataLoaded}
              onTimeUpdate={handleTimeUpdated}
              onEnded={handleEnded}
              ref={audRef}
              className="video-element"
              poster={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.poster}
            // style={{ maxWidth: "100%", maxHeight: "400px", padding: "10px 10px 0px 10px" }}
            // style={{ display: 'none' }}
            >
              <source
                // src={Data.enableMod[0].interact.media}
                src={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.media}
                type="video/mp4"
              />
              <track
                label="English"
                kind="subtitles"
                srcLang="en"
                src={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.transcript}
                default></track>
            </video>
            <main className="main">
              <AudioControlsSection
                audRef={audRef}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
                setCurrentTime={setCurrentTime}
                currentTime={currentTime}
                dataLoaded={dataLoaded}
                Data={Data}
                timelineIndex={timelineIndex}
                formatSectionHeaderStr={formatSectionHeaderStr}
                updateTime={updateTime}
                formatTime={formatTime}
              />
              <AnnotationSection
                Data={Data}
                timelineIndex={timelineIndex}
                formatTime={formatTime}
                formatSectionHeaderStr={formatSectionHeaderStr}
                updateTime={updateTime}
                version={version}
              />
            </main>
          </div >
          :
          <div>
            no data loaded
          </div>
        }
      </div>
    </div>
  );
}

export default ListeningGuide;